import React, { useState } from 'react';
import './css/loginstyle.css';
import { auth, db } from './firebase';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";

const Login = () => {
  const [isSignUp, setIsSignUp] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', type: '' });

  const showToast = (message, type = 'info') => {
    setToast({ show: true, message, type });
    setTimeout(() => setToast({ show: false, message: '', type: '' }), 4000);
  };

  const handleSignUpSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      await setDoc(doc(db, 'users', userCredential.user.uid), {
        firstName: name,
        email: email,
      });
      showToast('Sign-up successful! Please log in.', 'success');
      setIsSignUp(false);
      setName('');
      setPassword('');
    } catch (error) {
      showToast(error.message.replace('Firebase: ', ''), 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleSignInSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      window.location.href = "/";
    } catch (error) {
      showToast(error.message.replace('Firebase: ', ''), 'error');
      setLoading(false);
    }
  };

  const handleForgotPasswordClick = () => {
    if (email) {
      sendPasswordResetEmail(auth, email)
        .then(() => showToast('Password reset email sent! Check your inbox.', 'success'))
        .catch((error) => showToast(error.message.replace('Firebase: ', ''), 'error'));
    } else {
      showToast('Please enter your email address first.', 'warning');
    }
  };

  return (
    <div className="login-page">
      {/* Toast Notification */}
      {toast.show && (
        <div className={`login-toast ${toast.type}`}>
          <span className="toast-icon">
            {toast.type === 'success' ? '✅' : toast.type === 'error' ? '❌' : '⚠️'}
          </span>
          {toast.message}
        </div>
      )}

      <div className="login-container">
        <div className="login-image">
          <div className="login-image-overlay"></div>
          <div className="login-image-content">
            <span className="login-emoji">🌊</span>
            <h1>{isSignUp ? "Join the Wave" : "Welcome Back"}</h1>
            <p>{isSignUp ? "Create your account and start making a difference for our oceans." : "Sign in to continue your ocean conservation journey."}</p>
            <button
              onClick={() => setIsSignUp(!isSignUp)}
              className="toggle-form-btn"
            >
              {isSignUp ? "Already have an account? Sign In" : "New here? Create Account"}
            </button>
          </div>
        </div>
        <div className="login-form">
          {isSignUp ? (
            <form onSubmit={handleSignUpSubmit}>
              <h2>Create Account</h2>
              <p className="form-subtitle">Join 750+ ocean conservation volunteers</p>
              <div className="input-wrapper">
                <span className="input-icon">👤</span>
                <input
                  type="text"
                  placeholder="Full Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
              <div className="input-wrapper">
                <span className="input-icon">📧</span>
                <input
                  type="email"
                  placeholder="Email Address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="input-wrapper">
                <span className="input-icon">🔒</span>
                <input
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="submit-btn" disabled={loading}>
                {loading ? <span className="btn-loader"></span> : 'Create Account'}
              </button>
            </form>
          ) : (
            <form onSubmit={handleSignInSubmit}>
              <h2>Welcome Back</h2>
              <p className="form-subtitle">Log in to your OceanSense account</p>
              <div className="input-wrapper">
                <span className="input-icon">📧</span>
                <input
                  type="email"
                  placeholder="Email Address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="input-wrapper">
                <span className="input-icon">🔒</span>
                <input
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="submit-btn" disabled={loading}>
                {loading ? <span className="btn-loader"></span> : 'Sign In'}
              </button>
              <button
                type="button"
                className="forgot-password"
                onClick={handleForgotPasswordClick}
              >
                Forgot Password?
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
